/*======= Additional functions  =======*/
theme.helper = {
    checkEmail: function(email){
        var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (filter.test(email)){
            return true
        }else{
            return false
        }
    },

    checkIfEmpty: function(input){
        if( $(input).val().length > 0 && $(input).attr('type') == 'email'){
            return (this.checkEmail(input.val())) ? false : input;
        }else if( $(input).val().length > 0 ){
            return false
        }else{
            return input
        }
    },

    uniqueArr: function (arr){
        return Array.from(new Set(arr));
    }
};

/*======= Product Variants Change =======*/
theme.productVariants = {
  init: function (){

      let _this = this;

      $('.color-swatch').on('click', function (){
            let element = $(this),
                block = element.parent().parent().parent(),
                elements_wrapper = element.parent().parent();
            elements_wrapper.find('.color-swatch').removeClass('active');
            element.addClass('active');

            if(element.parent().hasClass('drawer-card__swatch')){
                _this.drawerChangeVariant(block, element);
            }else if(element.parent().hasClass('desktop-variants') || element.parent().parent().parent().hasClass('desktop-variants') ){
                _this.changeStickyBar(element);
            }else if(element.parent().hasClass('main-variant-mobile__swatch')){
                $('.actions-variants.mobile-variants').addClass('open');
            }else if(element.parent().hasClass('mobile-variants')){
                _this.changeStickyBarMobile(element);
            }else if(element.parent().hasClass('simple-colors')){
                _this.simpleChangeVariant(block, element);
            }else if(element.parent().hasClass('product-card__swatch')){
                _this.cardVariantSwatch(block, element);
            }else{
                _this.changeVariant(block, element);
            }
        });

      $('.main-variant-mobile').click(function(){
          $('.actions-variants.mobile-variants').addClass('open');
      });

      $('.color-swatch__other').click(function (){
              let element = $(this),
                  block = element.parent().parent().parent().parent();
              block.find('.color-swatch__other').removeClass('active');
              element.addClass('active');
              if(element.parent().hasClass('drawer-card__swatch')){
                  _this.drawerChangeVariant(block, element);
              }else if(block.hasClass('product-block')){
                  _this.cardVariantSwatchGift(block, element);
              }else{
                  _this.changeVariant(block, element);
              }
          });

      $('.amounts-buttons__wrapper button').click(function (ev) {
          ev.preventDefault();

          const $btn = $(this);
          const value = $btn.data('value');
          const variant_price = $btn.data('variant-price');
          const imgVariant = $btn.data('image');
          const $wrapper = $btn.parent();
          const $select = $wrapper.find('select');
          const $allAmountButtons = $('.amounts-buttons__wrapper button');
          const $mobileSwatch = $('.main-variant-mobile__swatch span');
          const $variantsAmountButtons = $('.variants--amount button');
          const $currentPriceDisplay = $('.product-details .current-price.theme-money');
          const $productBottomInfo = $('.product-bottom-actions__info p');
          const $stickyPrice = $('.product__sticky-add-to-cart .current-price.theme-money');
          const $stickyQtyInput = $('.sticky-product__qty input');
          const $bottomImage = $('.product-bottom-actions__info img');
          const $mainSlider = $('.product-main-slider');
          const $thumbnailsSlider = $('.product-thumbnails-slider');

          $allAmountButtons.removeClass('active');
          $btn.addClass('active');
          $mobileSwatch.text(value);
          $select.val(value).trigger('change');

          $variantsAmountButtons.removeClass('active');
          $('.variants--amount').find(`button[data-value="${value}"]`).addClass('active');

          $currentPriceDisplay.text(variant_price);
          $currentPriceDisplay.attr('data-currency-usd', variant_price);
          $productBottomInfo.text(value);
          $stickyPrice.data('currency-usd', value).text(value);

          $stickyQtyInput.val(1);

          if (typeof Currency !== 'undefined' && Currency.cookie.read() !== "USD") {
              Currency.convertAll("USD", Currency.cookie.read(), $stickyPrice);
          }

          $bottomImage.attr('src', imgVariant).attr('srcset', '');

          const currentVariantName = value.replaceAll(' ','-')
              .replaceAll('é', 'e')
              .replaceAll('/','-')
              .replaceAll('$',' ')
              .replaceAll('.','-')
              .trim()
              .toLowerCase();

          if (typeof theme.productSlider !== 'undefined' && theme.productSlider.mainSliderVariants) {
              $mainSlider.slick('unslick');
              $mainSlider.empty();

              const mainImagesArr = theme.productSlider.mainSliderVariants[currentVariantName] || [];

              mainImagesArr.forEach(function (image) {
                  $mainSlider.append(image);
              });

              theme.productSlider.initMainProductSlider();
          }

          if ($(window).width() > 767 && $thumbnailsSlider.hasClass('slick-initialized')) {
              if (typeof theme.productSlider !== 'undefined' && theme.productSlider.thumbnailsSliderVariants) {
                  $thumbnailsSlider.slick('unslick');
                  $thumbnailsSlider.empty();

                  const thumbnailsImagesArr = theme.productSlider.thumbnailsSliderVariants[currentVariantName] || [];

                  thumbnailsImagesArr.forEach(function (image) {
                      $thumbnailsSlider.append(image);
                  });

                  theme.productSlider.launchThumbnailsSliders();
              }
          }
      });

      $('.variants--amount button').click(function (ev){
          let btn = $(this);
          $('.variants--amount button').removeClass('active');
          btn.addClass('active');
          $('.sticky-product__qty input').val(1);

          let main_btn = $('.amounts-buttons__wrapper').find('button[data-value="'+btn.data('value')+'"]');
          $('.amounts-buttons__wrapper').find('button[data-value="'+btn.data('value')+'"]').trigger('click');

          if(btn.parent().hasClass('mobile-variants')){
              btn.parent().removeClass('open');
              $('.main-variant-mobile__swatch span').text(btn.data('value'));
          }
         
          Currency.convertAll("USD", Currency.cookie.read(), '.product__sticky-add-to-cart .theme-money');
      });

      $('.drawer-promo__add').click(function (){
          $('.drawer-promo__add').attr('disabled', true);
          _this.pairsAdd($(this));
      });

      $('.product-block .product-block__content .product-add').click(function (ev){
        ev.preventDefault();
        if(!$(this).hasClass('product-add--adding')){
            $(this).addClass('product-add--adding');

            let prop_info = ($(this).data('pre-order')) ? $(this).data('info') : false;
            _this.pairsAdd($(this), prop_info);
        }
      });

      $('#back-in-stock-notified').click(function(ev){
          ev.preventDefault();
          _this.backInStock($(this));
      });

      $('#back-in-stock-email').on('input', function (){
          $(this).removeClass('error-email');
      });

      $('.product-detail__pairs button').click(function(ev){
        ev.preventDefault();
        _this.pairsAdd($(this));
      });

      if($(window).width() > 768){
        _this.setDesktopImageHeight();
      }

      setTimeout(()=>{
        _this.createReChargePeriods();
        _this.reChargeActions();
        if($('body').hasClass('template-product')){
            _this.productStickyBar();
        }
        }, 1000);

      if($('.special-section-product-form').length > 0){
        $('.special-section-product-form').on('click', 'button', function (ev){
            ev.preventDefault();
            _this.pairsAdd($(this));
        });
      }
  },

    initRecommendedProducts: function (){
        let _this = this;

        $('.product-recommendations .color-swatch--more').click(function (){
            if($(this).hasClass('open-swatches')){
                $(this).removeClass('open-swatches');
                if($(this).hasClass('drawer-swatch')){
                    $(this).parent().find('.color-swatch.hide-on-drawer').addClass('hide');
                }else if(window.innerWidth > 1279){
                    $(this).parent().find('.color-swatch.hide-on-desktop').addClass('hide');
                }else{
                    $(this).parent().find('.color-swatch.hide-on-small-screens').addClass('hide');
                }
            }else if($(this).hasClass('drawer-swatch')){
                $(this).addClass('open-swatches').parent().find('.color-swatch.hide-on-drawer.hide').removeClass('hide');
            }else{
                $(this).addClass('open-swatches');
                if(window.innerWidth > 1279){
                    $(this).parent().find('.color-swatch.hide-on-desktop').removeClass('hide');
                }else{
                    $(this).parent().find('.color-swatch.hide-on-small-screens').removeClass('hide');
                }
            }
        });

        $('.product-recommendations .color-swatch').on('click', function (){
            let element = $(this),
                block = element.parent().parent().parent();
            block.find('.color-swatch').removeClass('active');
            element.addClass('active');

            _this.cardVariantSwatch(block, element);
        });

        $('.product-recommendations .product-add').click(function (ev){
            ev.preventDefault();
            if(!$(this).hasClass('product-add--adding')){
                $(this).addClass('product-add--adding');

                let prop_info = ($(this).data('pre-order')) ? $(this).data('info') : false;
                _this.pairsAdd($(this), prop_info);
            }
        });
    },

    setDesktopImageHeight: function (){
      let block_height = ($('.main.desktop').width())/3*4;

      $('.main.desktop').css("height", block_height);
  },

    cardVariantSwatchGift: function(block, element){
      let price = element.data('price');
      let title = element.data('variant-title');
      let id = element.data('variant-id');
      let img = element.data('variant-img');
      let img_hover = element.data('variant-hover-img');

      block.find('.product-detail__full-colors').text(title);
      block.find('.btn.product-add').data('variant', id);
      block.find('.amount.theme-money').text(price).attr('data-currency-usd', price);
      if(img != ''){
          block.find('.image__primary img').attr('src', img).attr('srcset', '');
      }

        //image__secondary
        if(!img_hover || img_hover.indexOf('/assets/no-image')> -1){
            img_hover= block.find('.image__secondary').data('hover');
        }

        block.find('.image__secondary img').attr('src', + img_hover);

      if($('select[name="currencies"]').val() != "USD"){
          var newCurrency = $('select.currencies').val();
          
          Currency.convertAll("USD", newCurrency);
      }
  },

    cardVariantSwatch: function (block, element) {
        const mainBlock = block.parent();
        const variantData = {
            id: element.data('variant-id'),
            available: element.data('available') === true,
            name: element.data('variant-title'),
            imgVariant: element.data('variant-img'),
            imgHover: element.data('variant-hover-img'),
            variantPrice: element.data('variant-price'),
            variantCompare: element.data('variant-compare') || '',
            productTitle: element.data('product')
        };

        const $priceElement = mainBlock.find('.price--custom-currency .amount.theme-money');
        const $comparePriceElement = mainBlock.find('del .theme-money');
        const $priceWrapper = mainBlock.find('.price--custom-currency');
        const $addButton = mainBlock.find('.product-add');
        const $notifyLink = mainBlock.find('.link-to-notify');
        const $mainLink = mainBlock.find('a.title');
        const $primaryImage = mainBlock.find('.image__primary img');
        const $secondaryImage = mainBlock.find('.image__secondary img');
        const mainHref = $mainLink.attr('href').split('?variant=')[0];
        const newVariantUrl = `${mainHref}?variant=${variantData.id}`;

        $priceElement.text(variantData.variantPrice).data('currency-usd', variantData.variantPrice);

        if (variantData.variantCompare) {
            if ($comparePriceElement.length) {
                $comparePriceElement.text(variantData.variantCompare).data('currency-usd', variantData.variantCompare).show();
            } else {
                const compareHtml = `<del><span class="theme-money" data-currency-usd="${variantData.variantCompare}">${variantData.variantCompare}</span></del>`;
                $priceWrapper.append(compareHtml);
            }
            $priceWrapper.addClass('on-sale');
        } else {
            if ($comparePriceElement.length) {
                $comparePriceElement.hide();
            }
            $priceWrapper.removeClass('on-sale');
        }

        if (typeof Currency !== 'undefined' && Currency.cookie.read() !== "USD") {
            Currency.convertAll("USD", Currency.cookie.read(), '.price--custom-currency .amount.theme-money');
            if (variantData.variantCompare) {
                Currency.convertAll("USD", Currency.cookie.read(), '.price--custom-currency del .theme-money');
            }
        }

        $addButton.data('variant', variantData.id);
        mainBlock.find('select[name="id"]').val(variantData.id);
        $mainLink.attr('href', newVariantUrl);
        mainBlock.find('.product-detail__full-colors').text(variantData.name);
        $notifyLink.attr('href', newVariantUrl);
        $primaryImage.attr('src', variantData.imgVariant).attr('srcset', '');

        let finalImgHover = variantData.imgHover;
        if (!finalImgHover || finalImgHover.indexOf('/assets/no-image') > -1) {
            finalImgHover = mainBlock.find('.image__secondary').data('hover') || '';
        }

        if (finalImgHover) {
            $secondaryImage.attr('src', finalImgHover);
        }

        if (!variantData.available) {
            $notifyLink.removeClass('hidden');
            $addButton.addClass('hidden').prop('disabled', true);
        } else {
            $notifyLink.addClass('hidden');
            $addButton.removeClass('hidden').prop('disabled', false);
        }
    },

    changeVariant: function (block, element){
      let _this = this,
          id = element.data('variant-id'),
          name = element.data('variant-title'),
          title = element.data('variant-full-name'),
          media = element.data('variant-media'),
          available = element.data('available'),
          variant_subtitle = element.data('subtitle'),
          variant_price = element.data('variant-price'),
          variant_compare = element.data('variant-compare'),
          variant_updated = element.data('updated-price');

      block.find('.original-selector').val(id).trigger('change');
      block.find('.product-detail__full-colors').text(title);
      block.find('#price .current-price.theme-money').text(variant_price).data('currency-usd', variant_price);

      if (block.find('#price .was-price.theme-money').length>0 && variant_compare != ''){
          block.find('#price .was-price.theme-money').text(variant_compare).data('currency-usd', variant_compare);
          block.find('#price .was-price.theme-money').css('display', 'inline');
          block.find('#price').addClass('on-sale');
      }else if (block.find('#price .was-price.theme-money').length>0 && variant_compare == ''){
          block.find('#price .was-price.theme-money').css('display', 'none');
          block.find('#price').removeClass('on-sale');
      }else if (block.find('#price .was-price.theme-money').length<1 && variant_compare != ''){
          block.find('#price').addClass('on-sale');
          block.find('#price').append('<span class="was-price theme-money" data-currency-usd="'+variant_compare+'">'+variant_compare+'</span>');
      }
      if (block.find('.promo-updated-price').length>0 && variant_updated != ''){
          block.find('.promo-updated-price').text(variant_updated).data('currency-usd', variant_updated);

          setTimeout(()=>{
                  _this.waitForElm(".yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-label-price").then(function() {
                      setTimeout(()=>{
                      let new_block = (document.querySelector('.theme-money.promo-updated-price')).cloneNode(true);
                      let place_after = document.querySelector('.yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-label-price');
                      let updated = document.querySelector('.yotpo-widget-subscriptions-add-to-cart .promo-updated-price');

                      if(!updated){
                          place_after.before(new_block);
                      }
                      }, 500);
                  })
              }, 200);
      }
      if( Currency.cookie.read() != "USD"){
          Currency.convertAll("USD", Currency.cookie.read(), '#price .current-price.theme-money');
      }

      if(variant_subtitle && variant_subtitle != ''){
          block.find('.product-detail__subtitle').empty().append(variant_subtitle);
      }

      if(!available){
          block.find('.back-in-stock ').removeClass('hidden');
          block.find('.back-in-stock .klaviyo-bis-trigger').css('display', 'inline-block');
      }else{
          block.find('.back-in-stock ').addClass('hidden');
      }

      let current_variant_name = name.replaceAll(' ','-').replaceAll('é', 'e').replaceAll('/','-').trim().toLowerCase();


      $('.product-main-slider').slick('destroy');
      $('.product-main-slider').empty();

      let mainImagesArr = theme.productSlider.mainSliderVariants[current_variant_name];

      mainImagesArr.forEach(function (image){
          $('.product-main-slider').append(image);
      })

      theme.productSlider.initMainProductSlider();


      if($(window).width() > 767 && $('.product-thumbnails-slider').hasClass('slick-initialized')){
          $('.product-thumbnails-slider').slick('destroy');
          $('.product-thumbnails-slider').empty();

          let thumbnailsImagesArr = theme.productSlider.thumbnailsSliderVariants[current_variant_name];

          thumbnailsImagesArr.forEach(function (image){
              $('.product-thumbnails-slider').append(image);
          });

          theme.productSlider.launchThumbnailsSliders();
      }

      _this.changeStickyBar(element);
      _this.changeStickyBarMobile(element);
    },

  changeStickyBarMobile: function(element){
        let _this = this,
            img_variant,
            id = element.data('variant-id'),
            name = element.data('variant-title'),
            available = element.data('available'),
            bar = $('.sticky--product-bottom-actions'),
            main_product = $('.product-detail__colors.product-page-section'),
            variant_price= element.data('variant-price'),
            variant_compare = element.data('variant-compare'),
            variant_updated = element.data('updated-price');


      $('.product__sticky-add-to-cart .current-price.theme-money').text(variant_price).data('currency-usd', variant_price);
      if ($('#sticky-price .was-price.theme-money').length>0 && variant_compare != ''){
          $('#sticky-price .was-price.theme-money').text(variant_compare).data('currency-usd', variant_compare);
          $('#sticky-price .was-price.theme-money').css('display', 'inline');
          $('#sticky-price').addClass('on-sale');
      }else if ($('#sticky-price .was-price.theme-money').length>0 && variant_compare == ''){
          $('#sticky-price .was-price.theme-money').css('display', 'none');
          $('#sticky-price').removeClass('on-sale');
      }else if ($('#sticky-price .was-price.theme-money').length<1 && variant_compare != ''){
          $('#sticky-price').addClass('on-sale');
          $('#sticky-price').append('<span class="was-price theme-money" data-currency-usd="'+variant_compare+'">'+variant_compare+'</span>');
      }
      if ($('#sticky-price .promo-updated-price').length>0 && variant_updated != ''){
          $('#sticky-price .promo-updated-price').text(variant_updated).data('currency-usd', variant_updated);
      }

      if( Currency.cookie.read() != "USD"){
          Currency.convertAll("USD", Currency.cookie.read(), '.product__sticky-add-to-cart .current-price.theme-money');
      }

      $('.actions-variants.mobile-variants').removeClass('open');
        let main_element = element.clone();
        $('.main-variant-mobile__swatch').empty().append(main_element).removeClass('active');

        if(!element.parent().hasClass('mobile-variants')){
            bar.find('.color-swatch').removeClass('active');
            bar.find('span[data-variant-id="'+id+'"]').addClass('active');
            img_variant = bar.find('span[data-variant-id="'+id+'"]').data('variant-image');
        }else{
            img_variant = element.data('variant-image');
            let new_element = main_product.find('span[data-variant-id="'+id+'"]');
            new_element.trigger('click');
        }

        if(available){
            bar.find('.actions-add .quantity').removeClass('hidden');
            bar.find('.actions-add .product__sticky-add-to-cart').removeClass('hidden');

            bar.find('.actions-add .stcky--back-in-stock ').addClass('hidden');
        }else{
            bar.find('.actions-add .stcky--back-in-stock ').removeClass('hidden');

            bar.find('.actions-add .quantity').addClass('hidden');
            bar.find('.actions-add .product__sticky-add-to-cart').addClass('hidden');
        }
    },

  changeStickyBar: function(element){
        let _this = this,
            img_variant,
            id = element.data('variant-id'),
            name = element.data('variant-title'),
            available = element.data('available'),
            bar = $('.sticky--product-bottom-actions'),
            main_product = $('.product-detail__colors.product-page-section');

        bar.find('.product-bottom-actions__info p').text(name);

        if(!element.parent().hasClass('desktop-variants') && !element.parent().parent().parent().hasClass('desktop-variants') ){
            bar.find('.color-swatch').removeClass('active');
            bar.find('span[data-variant-id="'+id+'"]').addClass('active');
            img_variant = bar.find('span[data-variant-id="'+id+'"]').data('variant-image');
            if(bar.find('.desktop-variants').hasClass('slick-initialized')){
                bar.find('.color-swatch').removeClass('slick-active slick-current');
            }
       }else{
            img_variant = element.data('variant-image');
            let new_element = main_product.find('span[data-variant-id="'+id+'"]');
            new_element.trigger('click');
        }

        bar.find('.product-bottom-actions__info img').attr('src', img_variant).attr('srcset', '');

        if(available){
            bar.find('.actions-add .quantity').removeClass('hidden');
            bar.find('.actions-add .product__sticky-add-to-cart').removeClass('hidden');

            bar.find('.actions-add .stcky--back-in-stock ').addClass('hidden');
        }else{
            bar.find('.actions-add .stcky--back-in-stock ').removeClass('hidden');

            bar.find('.actions-add .quantity').addClass('hidden');
            bar.find('.actions-add .product__sticky-add-to-cart').addClass('hidden');
        }

        $('.sticky-product__qty input').val(1);
    },

  simpleChangeVariant: function(block, element){
      let _this = this;
      let available = element.data('available'),
          name = element.data('variant-title'),
          variant = element.data('variant-id'),
          qty = element.data('variant-inv')*1,
          variant_price= element.data('variant-price');

      block.find('button').data('variant', variant);
      block.find('.link-to-notify').attr('href', element.data('link'));
      block.find('.theme-money').text(variant_price).data('currency-usd', variant_price);
      if( Currency.cookie.read() != "USD"){
          Currency.convertAll("USD", Currency.cookie.read(), '.product-detail__pairs-content .theme-money');
      }

      if(element.data('variant-image') != '') {
          block.find('.rimage__image').attr('src', element.data('variant-image'));
          block.find('.rimage__image').attr('srcset', '');
      }
      if(!available || available === "false"){
          block.find('.link-to-notify').removeClass('hidden');
          block.find('button').addClass('hidden');
      }else{
          block.find('.link-to-notify').addClass('hidden');
          block.find('button').removeClass('hidden');
      }

      if(block.hasClass('component--bundle')){
          block.data('component-variant', name);
          block.attr('data-component-id', variant);
          block.attr('data-component-inv', qty);

          let block_components = block.parent();
          let bundle_set_price = block_components.attr('data-bandle-set-price')*1;
          let product_c_price = block.attr('data-component-price')*100;
          let productn_v_price = element.attr('data-price')*1;

          if(productn_v_price != product_c_price){
              let ful_bundle_price = block_components.attr('data-bundle-full-price')*1;
              let new_ful_bundle_price = ful_bundle_price - product_c_price + productn_v_price;

              block.attr('data-component-price', (productn_v_price/100).toFixed(2));

              let updated_price = (new_ful_bundle_price < bundle_set_price) ? new_ful_bundle_price : bundle_set_price;

              $('.product-bundle-price .current-price.theme-money').text(updated_price);
              
              Currency.convertAll("USD", Currency.cookie.read(), '.product-bundle-price .current-price.theme-money');
              block_components.attr('data-bundle-full-price', new_ful_bundle_price);
          }

          let bundle_status = true;

          if(available){
              let bundle_dis = 0;
              $('.component--bundle').each(function (i, el){
                  if($(el).attr('data-component-inv')*1 < 1){bundle_dis++}
              });
              bundle_status = (bundle_dis>0) ? true : false ;
          }

          /*if(bundle_status){
         //   $('.payment-and-quantity--buttons-active.payment-and-quantity--with-quantity').addClass('hidden');
          }else{
          //    $('.payment-and-quantity--buttons-active.payment-and-quantity--with-quantity').removeClass('hidden');
          }*/

          $('.product-bundle__add .product-add').attr('data-disabled', bundle_status);
          $('.product__sticky-add-to-cart.sticky-for-bundle').attr('disabled', bundle_status);

          if($('.product-bottom-actions__info').length > 0){
              _this.changeVariantsSticky();
          }
      }

      
      const CSbundleContainer = block.closest('.cross-sell--bundle_container');

      if (!CSbundleContainer.length) {
          return;
      }

      const CSaddToCartButton = CSbundleContainer.find('.cross-sell--bundle__addToCart');
      const CSactiveVariants = block.parent().find('.color-swatch.active');
      const CScartJsonElement = $('#LimitedCartJson');

      if (!CSaddToCartButton.length || !CSactiveVariants.length) {
          return;
      }

      let CScartQuantities = {};
      if (CScartJsonElement.length) {
          try {
              const CScartData = JSON.parse(CScartJsonElement.html());
              CScartData.items.forEach(item => {
                  if (item.components) {
                      item.components.forEach(component => {
                          CScartQuantities[component.id] = (CScartQuantities[component.id] || 0) + component.quantity;
                      });
                  } else {
                      CScartQuantities[item.id] = (CScartQuantities[item.id] || 0) + item.quantity;
                  }
              });
          } catch (e) {
              CSaddToCartButton.prop('disabled', true);
              return;
          }
      }

      let CSunavailableVariantsCount = 0;
      CSactiveVariants.each((i, variant) => {
          const $variant = $(variant);
          const variantId = $variant.data('variant-id');
          const variantInv = $variant.data('variant-inv');

          if (variantInv < 1) {
              CSunavailableVariantsCount++;
              return;
          }

          const quantityInCart = CScartQuantities[variantId] || 0;
          if (variantInv - quantityInCart < 1) {
              CSunavailableVariantsCount++;
          }
      });

      const CSshouldBeDisabled = CSunavailableVariantsCount > 0;
      CSaddToCartButton.prop('disabled', CSshouldBeDisabled);
  },

  changeVariantsSticky: function (){
      let place_for_info = $('.product-bottom-actions__info p');
      let info = '';
      let bundle_elements = $('.block--bundle-components .component--bundle').length - 1;

      $('.block--bundle-components .component--bundle').each(function (i, element){
          let coma = '';
          let p_variant = '';
          if($(element).data('component-variant') != 'Default Title'){
              p_variant = ' - '+ $(element).data('component-variant');
          }

          if(i < bundle_elements){
              coma = ', ';
          }
          info += $(element).attr('data-component-name') + p_variant + coma;
      });

      place_for_info.text(info);
    },

  drawerChangeVariant: function (block, element){
      let main_block = block.closest('.cart-summary-item'),//block.parent(),
          id = element.data('variant-id'),
          img_variant = element.data('variant-img');

      main_block.find('button').data('variant', id);
      main_block.find('img').attr('src', img_variant).attr('srcset', img_variant);
  },

  backInStock: function (btn) {
      let notification_block = btn.parent();
      var email = $('#back-in-stock-email').val();
      var product = $('#back-in-stock-product').val();
      if(notification_block.hasClass('full-email') || email.length>3){
          if (!theme.helper.checkEmail(email)){
              $('#back-in-stock-email').addClass('error-email');
          }else{
              var quiz_obj = {
                  email: email,
                  variantApiId: product
              };

              $.ajax({
                  type: 'POST',
                  url: '/apps/skincare-quiz/add_stock_notification',
                  dataType: 'json',
                  data: JSON.stringify(quiz_obj),
                  success: function(data) {
                      $('#back-in-stock-email').removeClass('error-email');
                      if(data.success){
                          $('#back-in-stock-email').fadeOut();
                          $('#back-in-stock-notified').text('We will notify you!');
                          $('.variant-input.swatch-element input[type="radio"]:checked').addClass('notify');
                      }else{
                          notification_block.find('p').removeClass('hide');
                      }
                  },
                  error: function(XMLHttpRequest, textStatus) {
                      $('.back-in-stock p').addClass('hide');

                      notification_block.prepend('<p>'+textStatus+'</p>');
                      $('#back-in-stock-email').addClass('error-email');
                  }
              });
          }
      }else{
          $('#back-in-stock-email').fadeIn();
          notification_block.addClass('full-email');
      }
  },

  pairsAdd: function (btn, prop_info){
      let formData;
      if(prop_info){
          formData = {
              items: [{
                  id: btn.data('variant'),
                  quantity: 1,
                  properties: {
                      'Info' : prop_info
                  }
              }]
          }
      }else{
          formData = {
              items: [{
                  id: btn.data('variant'),
                  quantity: 1
              }]
          };
      }

     theme.promo.addToCart(formData, btn);
  },

  createReChargePeriods: function (){
      let _this = this;
      let buttons = "";
      $('.rc-selling-plans option').each(function (ind, element){
          let class_btn = (ind < 1) ? 'class="active"' : '';
          let button = "<button "+class_btn+" data-value='"+ element.value +"'>"+element.innerText.replace('Delivery every ', '')+"</button>";
          buttons += button;
      });
      let periods_block = "<div class='delivery-block'><p class='delivery-title'>Delivery every</p><div class='delivery-buttons'>"+ buttons +"</div></div>";
      $('.rc-radio.rc-radio--active.subscription-radio').append(periods_block);
      _this.showReChargePeriods();
  },

  showReChargePeriods: function (){
      $('.delivery-block').removeClass('hide');
  },

  hideReChargePeriods: function (){
      $('.delivery-block').addClass('hide');
  },

  reChargeActions: function (){
      let _this = this;
      $('input[name="purchaseOption"]').on('change click input', function (){
         if($(this).val() == 'subscription'){
             ($('.delivery-block').length > 0) ? _this.showReChargePeriods() : _this.createReChargePeriods();
         }else{
             _this.hideReChargePeriods();
         }
      });

      if($('input[name="purchaseOption"]:checked').val() == 'subscription'){
          ($('.delivery-block').length > 0) ? _this.showReChargePeriods() : _this.createReChargePeriods();
      }else{
          _this.hideReChargePeriods();
      }
      $('.product-form').on('click', '.delivery-buttons button', function (ev){
          ev.preventDefault();
          $('.delivery-buttons button').removeClass('active');
          $(this).addClass('active');
          let value = $(this).data("value");
          $('select[name="rc_selling_plan"]').val(value).change();
          $('input[name="selling_plan"]').val(value).prop(value);
      });
  },

  productStickyBar: function () {
      let _this = this;
      let sticky_bar = $('.sticky--product-bottom-actions');
      let bundle_sticky = $('.sticky--product-bottom-actions').hasClass('bundle-sticky');
      let scroll_position = 559;
      if ($(window).width() < 768){
        scroll_position = 960;
      }

      if(bundle_sticky){
          if($('form.product-form .payment-and-quantity .product-add').data('disabled')){
              sticky_bar.find('.product__sticky-add-to-cart.sticky-for-bundle').attr('disabled', true);
              if($('.back-in-stock')){
                  $('.back-in-stock').removeClass('hidden');
                 // $('form.product-form .payment-and-quantity').addClass('hidden');
              }
          }
      }

      if ($(window).scrollTop() > scroll_position) {
          if (sticky_bar.hasClass('hide')){
              sticky_bar.removeClass('hide');
          }
          _this.launchStickySlider();
      }else{
          if (!sticky_bar.hasClass('hide')){
              sticky_bar.addClass('hide');
          }
      }

    window.addEventListener('scroll', function(e) {

        if ($(window).scrollTop() + $(window).height() >= ( $(document).height() - 100 )) {
            if (!sticky_bar.hasClass('hide')){
                sticky_bar.addClass('hide');
            }
        }else if ($(window).scrollTop() > scroll_position) {
            if (sticky_bar.hasClass('hide')){
                sticky_bar.removeClass('hide');
                //Currency.convertAll("USD", Currency.cookie.read(), '.product__sticky-add-to-cart .theme-money');
            }
            _this.launchStickySlider();
        }else{
            if (!sticky_bar.hasClass('hide')){
                sticky_bar.addClass('hide');
            }
        }
    });

      $('.product__sticky-add-to-cart').click(function (){
        if ($(this).hasClass('sticky-for-bundle')){
            /*if($('form.product-form .payment-and-quantity .product-add').data('disabled')){
                $(this).attr('disabled', true);
            }else {*/
                $('.product-form').find('button.product-add').trigger('click');
         //   }
        }else {
            $('.product-form').submit();
        }
   });

      $('.product__sticky-scroll').click(function (){
          _this.scrollToVariants();
      });

      $('.stcky--back-in-stock .btn').click(function (){
          _this.scrollToVariants();
      });

      if(Currency.cookie.read() != "USD"){
          Currency.convertAll("USD", Currency.cookie.read(), '.theme-money');
      }

  },

  launchStickySlider: function (){
      let slider = $('.product-bottom-actions__actions .desktop-variants--slick');
      if(!slider.hasClass('slick-initialized')){
          slider.slick({
              slidesToShow: 4,
              slidesToScroll: 1,
              arrows: true,
              infinite: false,
              prevArrow: '<button type="button" class="slick-prev" aria-label="' + theme.strings.previous + '">' + theme.icons.chevronLeft + '</button>',
              nextArrow: '<button type="button" class="slick-next" aria-label="' + theme.strings.next + '">' + theme.icons.chevronRight + '</button>',
              dots: false});
      }
  },

  scrollToVariants: function (){
          var position = $('.product-form').offset().top - 150;
          $('.sticky--product-bottom-actions').addClass('hide');

          let klaviyo_block = document.querySelector('#backInStockKlaviyo');
          let klaviyo_btn = klaviyo_block.querySelector('.klaviyo-bis-trigger');

          $("body, html").animate({
              scrollTop: position
          }, 400 );

      this.customTrigger(klaviyo_btn, 'click');
  },

  customTrigger(el, eventType) {
    if (typeof eventType === 'string' && typeof el[eventType] === 'function') {
        el[eventType]();
    } else {
        const event =
            typeof eventType === 'string'
                ? new Event(eventType, {bubbles: true})
                : eventType;
        el.dispatchEvent(event);
    }
    },

  restartMobileSlider: function (variant) {
      let _this = this;
      let video_count = 0;
      let name = variant || window.productCurrently;
      let block_height = $('.mobile-slider.mobile').height();
      let medias;

      $('.mobile-slider.mobile').css("height", block_height + 'px');

      if(name == 'Default Title'){
          medias = window.productData.media;
      }else{
          medias = window.productData.media.filter(function( el ) {
              if(el.alt){
                  let alt_title = el.alt.split('--')[0].trim().toLowerCase();
                  return name.trim().toLowerCase() == alt_title
              }
          });

          if($('.mobile-slider').hasClass('slick-slider')){
              $('.mobile-slider').slick('unslick').empty();
          }else{
              $('.mobile-slider').empty();
          }

          $.each( medias , function (i, media){
              let img_url = media.preview_image.src;
              let content = '';
              if(media.media_type == "video"){
                content = '<div class="rimage-outer-wrapper mobile-slider-video" style="max-width: '+ media.preview_image.width +'px">\n' +
                    '                        <img class="rimage__image"\n' +
                    '                             src="'+ img_url +'"\n' +
                    '                             loading="lazy"\n' +
                    '                             width="'+ media.preview_image.width +'"\n' +
                    '                             height="'+ media.preview_image.height +'"\n' +
                    '                             alt="'+ media.alt +'">\n' +
                    '         <video onclick="theme.productVariants.mobileProductVideo(this)" class="hidden" playsinline src-mp4="'+media.sources[0].url+'">\n' +
                    '           <source src="'+media.sources[0].url+'" type=\'video/mp4\'>\n' +
                    '           Your browser does not support the video tag.\n' +
                    '         </video>\n' +
                    '         <button class="custom-video-wrap__button" onclick="theme.productVariants.mobileProductVideoButton(this)">' +
                    '           <span class="custom-video-wrap__button-play">'+ theme.strings.playButtonIcon +'</span><span class="custom-video-wrap__button-pause hidden">'+ theme.strings.pauseButtonIcon +'</span></button>\n' +
                    '      </div>';
                  video_count++;
              }else if(media.media_type == "image"){
                  content = '<img class="rimage__image" src="'+ img_url +'" loading="lazy" alt="'+ media.alt +'">';
              }

              $('.mobile-slider').append(content);
          });

          $('.mobile-slider').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              speed: 200,
              swipeToSlide: true,
              arrows: false,
              dots: true
          });

      }
     /* if(video_count > 0){
          _this.mobileProductVideo();
      }*/
  },

  mobileProductVideoButton: function(el){
            let video = el.previousElementSibling;
            let image = video.previousElementSibling;
            if (video.classList.contains("video-play-active")) {
                video.pause();
                video.classList.remove('video-play-active');
                el.querySelector('.custom-video-wrap__button-play').classList.remove('hidden');
                el.querySelector('.custom-video-wrap__button-pause').classList.add('hidden');
            } else {
                video.play();
                video.classList.add('video-play-active');
                video.classList.remove('hidden');
                image.classList.add('hidden');
                el.querySelector('.custom-video-wrap__button-play').classList.add('hidden');
                el.querySelector('.custom-video-wrap__button-pause').classList.remove('hidden');
            }
    },

  mobileProductVideo: function(video){
            if (video.classList.contains('video-play-active')) {
                video.pause();
                video.classList.remove('video-play-active');
            }
    },

    waitForElm: function(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }
};

theme.bundle = {
    openProductBundle: function (){
        let _this = this;
        $('.component--bundle__variants-button').click(function (ev){
            ev.preventDefault();
            ($(this).parent().hasClass('open-products-bundle')) ? _this.closeButtonBundle($(this)) : _this.openButtonBundle($(this));
        });
    },

    openButtonBundle: function (btn){
        let _this = this;
        _this.chooseProductForBundle(btn);
        btn.parent().addClass('open-products-bundle');
        btn.find('.content-button-components').removeClass('hidden');
    },

    closeButtonBundle: function (btn){
        let _this = this;
        btn.parent().removeClass('open-products-bundle');
        btn.find('.content-button-components').addClass('hidden');
    },

    chooseProductForBundle: function(block){
        let _this = this;

        block.on('click', '.component--bundle__variants-button-product', function (ev) {
            ev.preventDefault();

            let main_img = $(this).find('img').attr('src');
            let new_atributs = {
                product_title: $(this).find('h4').text(),
                main_img: main_img,
                product_id: $(this).data('id'),
                product_price: $(this).data('price'),
                product_inventory: $(this).data('inventory'),
                old_price_in_bundle: $(this).attr('data-prev-price'),
            };
            _this.updateFrontProductBundle(block, new_atributs);
            theme.productVariants.changeVariantsSticky();

            block.off( "click", ".component--bundle__variants-button-product");
        })
    },

    updateFrontProductBundle: function (block, obj){
        block.parent().attr('data-component-name', obj.product_title);
        block.parent().attr('data-component-id', obj.product_id);
        block.parent().attr('data-component-price', obj.product_price);
        block.find('h3 span').text(obj.product_title);
        block.parent().find('> img').attr('src', obj.main_img);
        block.parent().find('> img').attr('srcset', obj.main_img);
        block.parent().attr('data-component-prev-price', obj.old_price_in_bundle);
        block.parent().attr('data-component-inv', obj.product_inventory);

        block.parent().find('.component--bundle__variants-button-product').each(function (i, el){
            $(this).attr('data-prev-price', obj.product_price);
        });

        if(obj.product_price*1 != obj.old_price_in_bundle*1){
            let full_bundle_price = $('.block--bundle-components').attr('data-bundle-full-price');
            let new_full_bundle_price = full_bundle_price - obj.old_price_in_bundle*100 + obj.product_price*100;
            let bundle_set_price = $('.block--bundle-components').attr('data-bandle-set-price');

            $('.block--bundle-components').attr('data-bundle-full-price', new_full_bundle_price);

            if(new_full_bundle_price < bundle_set_price){
                $('.product-bundle-price .current-price.theme-money').text(new_full_bundle_price);
                $('.product__sticky-add-to-cart.sticky-for-bundle .current-price').text(new_full_bundle_price);

                Currency.convertAll("USD", Currency.cookie.read(), '.product-bundle-price .current-price.theme-money');
            }
        }
    },

    completeProductBundle: function (){
        let _this = this;
        $('.payment-and-quantity__add.product-bundle__add .product-add').click(function (ev){
            ev.preventDefault();

            let real_qty = _this.checkBundleQty()[0];
            let start_qty = _this.checkBundleQty()[1];

            if($(this).attr('data-disabled') =='true' ){
                let message = 'Please, choose another variants for your bundle!';
                let input = $('.payment-and-quantity--with-quantity .qty-adjuster__value');
                theme.showQuickPopup(message, input);
            }else if( real_qty*1 < $('.payment-and-quantity--with-quantity .qty-adjuster__value').val()*1 ) {
                let message = (real_qty>0) ? 'We only have - '+ real_qty +'more' : 'All our bundles in your cart!';
                let input = $('.payment-and-quantity--with-quantity .qty-adjuster__value');
                theme.showQuickPopup(message, input);
            }else{
                if(!$(this).hasClass('product-add--adding')){
                    $(this).addClass('product-add--adding');
                    _this.productBundleAddToCart($(this), real_qty, start_qty);
                    $('.payment-and-quantity__add.product-bundle__add').off( "click", ".product-add");
                }
            }
        });
    },

    checkBundleQty: function (){
        let cartItemData;
        let bundle_count = 100000;
        let start_count = 100000;

        $('.component--bundle').each(function (i, el){
            let variant = $(el).attr('data-component-id')*1;
            let qty = $(el).attr('data-component-inv')*1;
            let r_qty = qty;

            if(start_count>qty){ start_count = qty}

            if ($('#LimitedCartJson').length>0) {
                cartItemData = JSON.parse($('#LimitedCartJson').html());
                for(let i = 0; cartItemData.items.length>i; i++){
                    if(cartItemData.items[i].id*1 == variant){
                        r_qty = qty - cartItemData.items[i].quantity
                    }
                }
                if(bundle_count>r_qty){ bundle_count = r_qty}
            }

        })

        // $('.payment-and-quantity--with-quantity .qty-adjuster__value').attr('max',bundle_count);

        return [bundle_count, start_count]
    },

    productBundleAddToCart: function (btn, real_qty, start_qty){
        let _this = this,
            arr_items = [],
            formData = {};

        let bundle_components = [];
        let bundle_qty = btn.parent().parent().find('.qty-adjuster__value').val();
        let bundleCoverVariantID = "gid://shopify/ProductVariant/"+ (btn.attr('data-bundle-id').trim());
        let bundleNewPrice = btn.attr('data-bundle-price').replace('bundle-discount:', '').trim();
        let bundleChanges = 'am-'+bundleNewPrice;
        let bundleTag = (btn.attr('data-bundle-tag')) ? btn.attr('data-bundle-tag').replace('bundle-discount:', '').trim() : false;
        if(bundleTag){
            bundleChanges = 'pr-'+ bundleTag;
        }

        $('.component--bundle').each(function() {
            bundle_components.push( $(this).attr('data-component-id'));
        });

        let arr_ids = [...bundle_components];
        arr_ids.sort(function(a, b) {
            return a*1 - b*1;
        });

        let bundleId = "bundle-id";
        arr_ids.forEach(function (el){
            bundleId = bundleId + '-' + el;
        });

        let uniq_components = [];
        let components_count = [];
        for(let i = 0; i < bundle_components.length; i++){
            if(uniq_components.indexOf(bundle_components[i]) === -1){
                uniq_components.push(bundle_components[i]);
                let comp_count = _this.getOccurrence(bundle_components, bundle_components[i]);
                components_count.push(comp_count);
            }
        }

        for(let i = 0; i < uniq_components.length; i++){
            let item = {
                id: uniq_components[i],
                quantity: bundle_qty * components_count[i],
                properties: {
                    _bundle_uniq_id: bundleId,
                    _bundle_cover: bundleCoverVariantID,
                    _bundle_changes: bundleChanges,
                    _bundle_type: "Custom",
                    _bundle_qty_per: components_count[i],
                }
            }

            arr_items.push(item);
        }

        formData['items'] = arr_items;
        theme.promo.addToCart(formData, btn);
    },

    getOccurrence: function(array, value) {
        var count = 0;
        array.forEach((v) => (v === value && count++));
        return count;
    }
}

/*======= cart-drawer-pop-up-gift-option =======*/
theme.giftOptions = {
    init: function () {
        let _this = this;

        $('.cart-drawer__gifting-option').on('click', '#gifting-option', function () {
            _this.changeCartGiftOption();
        });
        $('.cart-form--checkout').on('click', '#cart-gifting-wrap-option', function () {
            _this.changeCartGiftOption();
        });
    },

    changeCartGiftOption: function (){
        let _this = this;
        if ($('#gifting-option').prop('checked') || $('#cart-gifting-wrap-option').prop('checked')) {
            $('.cart-drawer__pop-up-gift-option').removeClass('hide');
            if($('#gifting-wrap-option').length>0){
                $('#gifting-wrap-option').attr('checked', true).prop('checked', true);
            }
            _this.popUpActions();
        }else {
            let gift_options = {
                "Gift Receipt": 'No',
                "Gift Message": 'No'
            };

            $('#gift_message').attr('checked', false).prop('checked', false);
            $('#gift_message_text').val('').addClass('empty_textarea');
            $('#gift_receipt').attr('checked', false).prop('checked', false);

            let wrap_in_cart = false;
            let wrap_id = false;
            if($('.cart-form.cart-summary__section .cart-summary-item.wrap-product').length> 0){
                wrap_in_cart = true;
            }
            if(wrap_in_cart && $('.cart-summary__section .cart-summary-item.wrap-product').length> 0){
                wrap_id = $('.cart-summary__section .cart-summary-item.wrap-product').parent().data('product-id');
            }

            let product_wrap = {
                "action": "remove",
                "productVId": wrap_id
            };

            if(wrap_in_cart){
                _this.setGiftAttribute(gift_options, product_wrap);
            }else{
                _this.setGiftAttribute(gift_options);
            }

        }
    },

    checkGiftOptions: function (attributes) {
        let checkbox_count = 0;
        if (attributes['Gift Receipt'] === "Yes") {
            checkbox_count++;
            if (!$('#gift_receipt').prop('checked')) {
                $('#gift_receipt').attr('checked', true).prop('checked', true);
            }
        } else {
            if ($('#gift_receipt').prop('checked')) {
                $('#gift_receipt').attr('checked', false).prop('checked', false);
            }
        }
        if (attributes['Gift Message'] != "No") {
            checkbox_count++;
            if (!$('#gift_message').prop('checked')) {
                $('#gift_message').attr('checked', true).prop('checked', true);
            }
            $('#gift_message_text').val(attributes['Gift Message']).text(attributes['Gift Message']);
        } else {
            if ($('#gift_message').prop('checked')) {
                $('#gift_message').attr('checked', false).prop('checked', false);
            }
            $('#gift_message_text').val('').text('');
        }

        if (checkbox_count > 0) {
            $('#gifting-option').attr('checked', true).prop('checked', true);
        } else {
            $('#gifting-option').attr('checked', false).prop('checked', false);
        }

        $('.cart-drawer__pop-up-gift-option').addClass('hide');
    },

    popUpActions: function () {
        let _this = this;
        $('.save-gift-options').click(function () {
            let gift_options = {
                "Gift Receipt": 'No',
                "Gift Message": 'No'
            };
            let checkbox_count = 0;

            if ($('#gift_receipt').prop('checked')) {
                gift_options["Gift Receipt"] = "Yes";
                checkbox_count++;
            }

            if ($('#gift_message').prop('checked')) {
                if ($('#gift_message_text').val().trim().length > 0) {
                    gift_options["Gift Message"] = $('#gift_message_text').val();
                    checkbox_count++;
                } else {
                    $('#gift_message_text').addClass('empty_textarea');
                }
            }

            if($('.cart-form .cart-drawer__gifting-wrap-option')){
                let wrap_checked = false;
                let wrap_in_cart = false;
                let wrap_id;
                let product_wrap = {};
                if ($('.gift-option__content  #gifting-wrap-option').prop('checked')) {
                    wrap_checked = true;
                }
                if($('.gift-option__content .cart-summary-item.wrap-product').length> 0){
                    wrap_in_cart = true;
                }

                if($('.gift-option__content .cart-drawer__gifting-wrap-option.cart-summary-item').length> 0){
                    wrap_id = $('.gift-option__content .cart-drawer__gifting-wrap-option.cart-summary-item').data('product-wrap');
                }

                if(!wrap_in_cart && wrap_checked && wrap_id){
                    product_wrap = {
                        "action": "add",
                        "productVId": wrap_id
                    };
                    _this.setGiftAttribute(gift_options, product_wrap);
                } else if(!wrap_checked && wrap_in_cart && wrap_id){
                    product_wrap = {
                        "action": "remove",
                        "productVId": wrap_id
                    };
                    _this.setGiftAttribute(gift_options, product_wrap);
                }else{
                    _this.setGiftAttribute(gift_options);
                }
                _this.mainGiftCheckbox();
            }
        });


        $('#gift_message_text').on('input', function () {
            _this.changeGiftTextArea();
            if ($('#gift_message_text').val().trim().length > 0) {
                $('#gift_message_text').removeClass('empty_textarea');
            }
            if (!$('#gift_message').prop('checked') && $('#gift_message_text').val().trim().length > 3) {
                $('#gift_message').attr('checked', true).prop('checked', true);
            }
        });

        $('#gift_message').change(function () {
            if (!$('#gift_message').prop('checked')) {
                $('#gift_message_text').removeClass('empty_textarea');
            }
        });

        $('.cart-drawer__pop-up-gift-option .close-gift-option').click(function (){
            /*$.ajax({
                type: 'GET',
                url: '/cart.js',
                dataType: 'json',
                success: function(cart) {
                    _this.checkGiftOptions(cart.attributes);
                }
            });*/
            $('#gift_message').attr('checked', false).prop('checked', false);
            $('#gift_receipt').attr('checked', false).prop('checked', false);
            $('#gift_message_text').val('');
            $('.cart-drawer__pop-up-gift-option').addClass('hide');
            $('#cart-gifting-wrap-option').attr('checked', false).prop('checked', false);

        });
    },

    mainGiftCheckbox: function () {
        let checkbox_count = 0;

        if ($('#gift_receipt').prop('checked')) {
            checkbox_count++;
        }
        if ($('#gift_message').prop('checked') && ($('#gift_message_text').val().trim().length > 0)) {
            checkbox_count++;
        }
        if ($('#gifting-wrap-option').prop('checked')) {
            checkbox_count++;
        }

        if (checkbox_count > 0) {
            $('#gifting-option').attr('checked', true).prop('checked', true);
            $('#cart-gifting-wrap-option').attr('checked', true).prop('checked', true);
        } else {
            $('#gifting-option').attr('checked', false).prop('checked', false);
            $('#cart-gifting-wrap-option').attr('checked', false).prop('checked', false);
        }
    },

    setGiftAttribute: function (gift_options, product_wrap) {
        let dataForm = {};
        
        if(product_wrap){
            if(product_wrap.action != "add"){
                let items = {};
                items[product_wrap.productVId] = 0;
                dataForm['updates'] = items;
            }
        }

        dataForm['attributes'] = gift_options;

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataForm)
        }).then(response => {
            if(product_wrap){
                if(product_wrap.action == "add"){
                    let itemData = {
                        items: [{
                            id: product_wrap.productVId,
                            quantity: 1,
                            properties: {
                                '_product-type': 'wrap-product'
                            }
                        }]
                    };
                    theme.promo.addToCart(itemData);
                }else{
                    theme.promo.updatingCart();
                }
            }else{
                $('.cart-drawer__pop-up-gift-option').addClass('hide');
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    },

    changeGiftTextArea: function () {
        let text_length = $('#gift_message_text').val().length;
        $('.gift-option__content .text-count span').text(250 - text_length);
    }

};

/*======= Promo & Gifts in Cart Drawer  =======*/
theme.cartGifts = {

    init: function (cartItemData){
        let _this = this;

       /* if(cartItemData && cartItemData.items && cartItemData.items.length>0){
            _this.removePromoGifts(cartItemData.items);
        }*/

        if ($('.cart-drawer__samples').length > 0){
            $('.add-sample').click(function (){
                $('.add-sample').attr('disabled', true);
                _this.addSample($(this))
            });
        }

        if($('.cart-drawer__product-with-gift').length > 0){
            $('.cart-drawer__product-with-gift button').click(function (){
                $(this).attr('disabled', true);
                _this.addProductWithGift($(this))
            });
        }
        /*if(cartItemData){
            _this.checkGiftWithProduct(cartItemData);
        }*/
    },

    removePromoGifts: function (cartItems){
        let products_to_remove = {};
        let remove_count = 0;

        if(!theme.promoGWP.enable){
            cartItems.forEach(function (el){
                if(el.properties && el.properties['_product-type'] && el.properties['_product-type'] == 'promos_gwp'){
                    products_to_remove[el.line] = 0;
                    remove_count ++;
                }
            })
        }
        if(!theme.promoBMGM.enable){
            cartItems.forEach(function (el){
                if(el.properties && el.properties['_product-type'] && el.properties['_product-type'] == 'promos_bmgm'){
                    products_to_remove[el.line] = 0;
                    remove_count ++;
                }
            })
        }
        
        if(remove_count > 0){
            let formDataUp = {
                updates: products_to_remove
            };
            
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formDataUp)
            }).then(response => {
                theme.promo.updatingCart();
            }).catch((error) => {
                console.error('Error:', error);
            });
        }
    },

    addSample: function (btn){
        let formData = {
            items: [{
                id: btn.data('sample-id'),
                quantity: 1,
                properties: {
                    '_product-type': 'free-sample'
                }
            }]
        };
        theme.promo.addToCart(formData);
    },

    addProductWithGift: function (btn){
        let formData = {
            items: [{
                id: btn.data('main-product'),
                quantity: 1,
                properties: {
                    '_product-type': 'product_with_gift'
                    }
                },{
                id: btn.data('gift'),
                quantity: 1,
                properties: {
                    '_product-type': 'gift'
                    }
                }
            ]
        };

        theme.promo.addToCart(formData);
    },

    checkGiftWithProduct: function (data){

        let _this = this,
            items = data.items,
            sum = data.sum_total,
            gift,
            gift_qty,
            gift_count = 0,
            sample,
            sample_qty,
            sample_count = 0,
            change_items = {},
            has_sample = false,
            has_gift = false,
            product_with_gift = false;

        /*if(data && data.items && data.items.length>0){
            _this.removePromoGifts(data.items);
        }*/

        $.each(items, function (ind, item){
            if(item.properties && item.properties['_product-type']){
                if(item.properties['_product-type'] == 'product_with_gift'){
                    product_with_gift = true;
                }
                if(item.properties['_product-type'] == 'gift'){
                   gift = item;
                   has_gift = true;
                   gift_qty = item.quantity;
                   gift_count +=1;
                }
                if(item.properties['_product-type'] == 'free-sample'){
                    sample = item;
                    has_sample = true;
                    sample_qty = item.quantity;
                    sample_count +=1;
                }
            }
        });

        if(!product_with_gift && has_gift){
            change_items[gift.line] = 0;
        }else if(product_with_gift && has_gift && gift_qty > 1){
            change_items[gift.line] = 1;
        }else if(product_with_gift && gift_count > 1){
            change_items[gift.line] = 0;
        }

        if(sum < 9.9 && has_sample){
            change_items[sample.line] = 0;
        }else if(sum > 9.9 && has_sample && sample_qty > 1){
            change_items[sample.line] = 1;
        }else if(sum > 9.9 && sample_count > 1){
            change_items[sample.line] = 0;
        }

        if ($.isEmptyObject(change_items)) {
            theme.drawingCart();
            setTimeout(function (){
                if($('.promo-popUp.open--pop-up').length < 1 && $('.promo-popUp.open--next').length < 1 ){
                    $('#cart-summary').removeClass('disabled-cart__while-pop-up');
                }
            }, 400);
        }else{
            _this.updateCart(change_items);
        }
    },

    updateCart: function (items) {
        let formData = {
            updates: items
        };

        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(response => {
            theme.promo.updatingCart();
        }).catch((error) => {
            console.error('Error:', error);
        });
    },

    cartDrawerPromo: function(section){
        $('.drawer-promo__add').attr('disabled', false);
        section.find('.color-swatch').click(function () {
            let element = $(this),
                block = element.parent().parent().parent();
            block.find('.color-swatch').removeClass('active');
            element.addClass('active');
            theme.productVariants.drawerChangeVariant(block, element);
        });

        $('.drawer-promo__add').click(function (){
            $('.drawer-promo__add').attr('disabled', true);
            theme.productVariants.pairsAdd($(this));
        });

        $('.cart-summary__promo-products .color-swatch--more.drawer-swatch').click(function (){
            if($(this).hasClass('open-swatches')){
                $(this).parent().find('.color-swatch.hide-on-drawer').addClass('hide');
                $(this).removeClass('open-swatches');
            }else{
                $(this).addClass('open-swatches').parent().find('.color-swatch.hide-on-drawer.hide').removeClass('hide');
            }
        })

        document.querySelector('.cart-summary__promo-products .cart-summary__section').addEventListener('wheel', function(event) {
          if (event.deltaMode == event.DOM_DELTA_PIXEL) {
              var modifier = 1;
              // Firefox
          } else if (event.deltaMode == event.DOM_DELTA_LINE) {
              var modifier = parseInt(getComputedStyle(this).lineHeight);
          } else if (event.deltaMode == event.DOM_DELTA_PAGE) {
              var modifier = this.clientHeight;
          }
          if (event.deltaY != 0) {
              this.scrollLeft += modifier * event.deltaY;
              event.preventDefault();
          }
      });
    }
};

/*======= find Country by geolocation server and sent to session  =======*/
theme.FindCountry = {

    async getCountryShopifyApi(){
        try {
            const apiUrl = `${window.Shopify.routes.root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${window.Shopify.country}&language[enabled]=true&language[exclude]=${window.Shopify.language}`;
            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error(`HTTP error! State: ${response.status}`);
            }
            const data = await response.json();
            const customer_country = data.detected_values.country.handle;

            sessionStorage.setItem('sb-cc', customer_country);
            return customer_country;

        } catch (error) {
            console.log(error);
            return "US"
        }
    },

    async checkCountry() {
        const storedCountry = sessionStorage.getItem('sb-cc');
        if (storedCountry && storedCountry !== "") {
            return storedCountry;
        } else {
            return await this.getCountryShopifyApi();
        }
    }
    
};

theme.progressTiered = {
    progressBar: document.querySelector('.progress-bar--tiered'),
    points: [],
    
    createPointsObjects: function (isUs, cartSumm) {
        const _this = this;

        _this.createShippingPoint(isUs);
        _this.createGWPPoint();
        _this.createBMGMPoints();

        function compareBySum(a, b) {
            const sumA = parseFloat(a.sum);
            const sumB = parseFloat(b.sum);
            return sumA - sumB;
        }

        const sortedPoints = _this.points.sort(compareBySum);
        _this.setPoints(sortedPoints, cartSumm);
    },
    
    check: function (cart_total_price) {
        console.log('cart - ', cart_total_price);
        const _this = this;
        setTimeout(function () {
            _this.updateProgress(cart_total_price);
        }, 400)
    },

    updateProgress: function (cart_total_price){
        const progressBar = document.querySelector('.progress-bar--tiered');
        const m_unlocked = document.querySelector('.progress-bar--tiered-messages .unlocked-gift');
        const m_to = document.querySelector('.progress-bar--tiered-messages .to-gift');
        const stripe = document.querySelector('.progress-bar--tiered .progress-bar__stripe');
        const messageCurrencyFormat = "${{amount_no_decimals}} USD";
        const points = this.points;
        const pointSpace = 100 / points.length;
        const max_sum_obj = points[points.length - 1];
        const max_sum = parseFloat(max_sum_obj.sum);
        const min_sum_obj = points[0];
        const min_sum = parseFloat(min_sum_obj.sum);
        
        if (max_sum <= 0) return;

        const isGloballyComplete = cart_total_price >= max_sum*100;

        let progress_percentage = '0';

        if (isGloballyComplete) {
            progress_percentage = '100';
            let m_text_l = m_unlocked.textContent;
            let nextGiftTitle = points[points.length - 1].title;
            m_unlocked.innerHTML = m_text_l.replace('{offer}', nextGiftTitle);
            m_unlocked.style.display = 'block';
            m_to.style.display = 'none';
        }else if(min_sum*100 > cart_total_price*1){
            const f_pointSum = points[0].sum*100;
            progress_percentage = pointSpace * cart_total_price / f_pointSum;
            let sum_before = Math.ceil((f_pointSum - cart_total_price*1)/100)*100;
            let formattedRemaining = Currency.formatMoney(sum_before, messageCurrencyFormat);
            let firstGiftTitle = points[0].title;
            let m_text = m_to.textContent;
            setTimeout(()=>{
                m_to.innerHTML = m_text.replace('{total}', formattedRemaining).replace('{offer}', firstGiftTitle);
                m_to.style.display = 'block';
                }, 200);
        }else{
            points.forEach((point, i) => {
                const pointSum = point.sum*100;
                const pointElement = document.getElementById(point.id);
                if(cart_total_price >= pointSum ){
                    pointElement.classList.add('unlocked');

                    if(points[i+1]){
                        const nextPoint = points[i+1];
                        const n_pointSum = parseFloat(nextPoint.sum) * 100;

                        if(cart_total_price < n_pointSum ) {
                            const segmentTotal = n_pointSum - pointSum;
                            const segmentProgress = cart_total_price - pointSum;

                            const segmentProgressPercentage = (segmentTotal > 0)
                                ? (segmentProgress / segmentTotal) * pointSpace
                                : 0;

                            progress_percentage = (i + 1) * pointSpace + segmentProgressPercentage;
                            let sum_before = Math.ceil((n_pointSum - cart_total_price*1)/100)*100;
                            let formattedRemaining = Currency.formatMoney(sum_before, messageCurrencyFormat);
                            let nextGiftTitle = points[i+1].title;

                            let m_text = m_to.textContent;
                            setTimeout(()=> {
                                m_to.style.display = 'block';
                                m_to.innerHTML = m_text.replace('{total}', formattedRemaining).replace('{offer}', nextGiftTitle);
                            })
                        }
                    }
                }
            })
        }

        stripe.style.width = `${progress_percentage}%`;
        progressBar.classList.add('updated-bar');
    },

    _addPointIfValid: function(id, selector, sum, pointTitle) {
        const isDuplicate = this.points.some(p => p.id === id);
        if (isDuplicate) {
            return false;
        }

        const pointElement = this.progressBar.querySelector(selector);
        if (pointElement && parseFloat(sum) > 0) {
            const point_obj = {
                point: selector,
                id: id,
                sum: sum.toString(),
                title: pointTitle,
            };
            this.points.push(point_obj);
            return true;
        }
        return false;
    },

    setPoints: function (pointsArray, cart_total_price) {
        const totalPoints = pointsArray.length;
        if (totalPoints === 0) return;

        const pointSpace = 100 / totalPoints;
        const element_width = 290 / totalPoints;

        pointsArray.forEach((point, i) => {
            const positionPercentage = (i + 1) * pointSpace;
            const match = point.point.match(/#([^.]+)/);
            const elementId = match ? match[1] : null;

            let pointElement;

            if (elementId) {
                pointElement = document.getElementById(elementId);
            } else {
                pointElement = this.progressBar.querySelector(point.point);
            }

            if (pointElement) {
                pointElement.style.left = `${positionPercentage}%`;
                pointElement.style.opacity = '1';
                pointElement.style.zIndex = '1';
                pointElement.style.width = `${element_width}px`;
            }
        });

        const _this = this;
        setTimeout(function () {
            _this.updateProgress(cart_total_price);
        }, 400)
    },

    createShippingPoint: function (isUS){
        const shippingPoint = this.progressBar.querySelector('#point-shipping');
        if (!shippingPoint) return;

        const sumKey = isUS ? 'data-sum' : 'data-int-sum';
        const sum = shippingPoint.getAttribute(sumKey);
        const pointTitle = shippingPoint.querySelector('span').textContent;
        this._addPointIfValid('point-shipping', '#point-shipping', sum, pointTitle);
    },

    createGWPPoint: function (){
        const gwpPoint = this.progressBar.querySelector('#point-gwp');
        if (!gwpPoint) return;

        const promo = theme.promoGWP;
        const isEnabled = promo && promo.enable && promo.minCartValue > 0;
        const hasGift = promo.giftCollection || promo.giftProductFirst || promo.giftProductSecond || promo.giftProductThird;

        if (isEnabled && hasGift) {
            const startDay = $('body').data("customer-vip") ? promo.vipStartDay : promo.startDay;
            const startGWP = new Date(promo.startYear, promo.startMonth, startDay, promo.startHours, promo.startMinutes, 0).getTime();
            const finishGWP = new Date(promo.finishYear, promo.finishMonth, promo.finishDay, promo.finishHours, promo.finishMinutes, 0).getTime();

            if (this.checkPromoPeriod(startGWP, finishGWP)) {
                const pointTitle = gwpPoint.querySelector('span').textContent;
                this._addPointIfValid('point-gwp', '#point-gwp', promo.minCartValue, pointTitle);
            } else {
                gwpPoint.style.display = 'none';
            }
        } else {
            gwpPoint.style.display = 'none';
        }
    },

    createBMGMPoints: function (){
        const allBMGMPoints = this.progressBar.querySelectorAll('.point-bmgm');
        const promo = theme.promoBMGM;

        if (allBMGMPoints.length === 0 || !promo || !promo.enable) return;

        const startBMGM = new Date(promo.startYear, promo.startMonth, promo.startDay, promo.startHours, promo.startMinutes, 0).getTime();
        const finishBMGM = new Date(promo.finishYear, promo.finishMonth, promo.finishDay, promo.finishHours, promo.finishMinutes, 0).getTime();

        if (this.checkPromoPeriod(startBMGM, finishBMGM)) {
            this._processBmgmPoint(
                'point-bmgm1',
                promo.firstMinCartValue,
                promo.firstGiftProduct
            );
            this._processBmgmPoint(
                'point-bmgm2',
                promo.secondMinCartValue,
                promo.secondGiftProduct1 || promo.secondGiftProduct2
            );
            this._processBmgmPoint(
                'point-bmgm3',
                promo.thirdMinCartValue,
                promo.thirdGiftProduct1 || promo.thirdGiftProduct2 || promo.thirdGiftProduct3
            );
        } else {
            allBMGMPoints.forEach(point => point.style.display = 'none');
        }
    },

    _processBmgmPoint(id, minValue, giftCondition) {
        const selector = `#${id}`;

        if (minValue > 0 && giftCondition) {
            const pointElement = document.getElementById(id);
            
            if (pointElement) {
                const pointTitleSpan = pointElement.querySelector('span');
                const pointTitle = pointTitleSpan ? pointTitleSpan.textContent : 'Promotion Point';

                this._addPointIfValid(id, selector, minValue, pointTitle);
            } else {
                console.warn(`BMGM Point element not found: ${id}`);
            }
        } else {
            const point = this.progressBar.querySelector(selector);
            if (point) {
                point.style.display = 'none';
            }
        }
    },

    checkPromoPeriod: function (start, finish){
        const _this = this;
        let day_now = _this.findTimeNow();
        let time_now = new Date(day_now).getTime();
        return start < time_now && time_now < finish
    },

    findTimeNow: function () {
        let customer_time_zone = new Date().getTimezoneOffset();
        let client_time_zone = 300;
        let time_zone = client_time_zone - customer_time_zone;
        return (-time_zone * 60 * 1000 + Date.now());
    },
}

/*======= navigate Custom video block  =======*/
theme.customVideo = {
    onSectionLoad: function (section) {
        let _this = theme.customVideo;
        let video_button = section.querySelectorAll('.section-video .custom-video-wrap__button');
        let video = section.querySelectorAll('.custom-video-wrap video');

        Array.prototype.forEach.call(video_button, function(el, i){
            el.addEventListener('click', function (ev) {
                _this.clickButton(this);
            });
        });
        Array.prototype.forEach.call(video, function(el, i){
            el.addEventListener('click', function (el) {
                _this.clickVideo(this);
            });
        });
    },

    clickButton: function (btn){
        let video = btn.previousElementSibling;
        if (video.classList.contains("video-play-active")) {
            video.pause();
            video.classList.remove('video-play-active');
        } else {
            video.play();
            video.classList.add('video-play-active');
        }
    },

    clickVideo: function (video){
        if (video.classList.contains('video-play-active')) {
            video.pause();
            video.classList.remove('video-play-active');
        }
    }

};

theme.recentlyViewed = {
    init: ()=>{
        let _this = theme.recentlyViewed;
        let products_arr = localStorage.getItem("r-v-p");
        let blocks_parent = $('.section-recently-viewed .product-grid');
        if (products_arr && products_arr.length>0 ){
            _this.createSection(products_arr, blocks_parent);
        }else{
            _this.hideSection();
        }
    },

    hideSection: ()=>{
        $('.section-recently-viewed .product-grid').addClass('hide hidden');
    },

    createSection: (products_arr, blocks_parent)=>{
        let section_products_count = 0;
        let reversed_arr = products_arr.replaceAll('product-', '').split(', ').reverse();
        let current_product = ($('.section-recently-viewed').data('product'))? $('.section-recently-viewed').data('product').trim() : 'not_product' ;

        $.each(reversed_arr, function (ind, str_handle){
            let handle = str_handle.trim();

            if(ind > 12){
                return
            }else{
                if(handle) {
                    if (current_product != handle) {
                        $.get('/products/' + handle + '?section_id=product-recently-template').then(function (data) {
                            let data_html = $(data).find('.product-block');
                            if(!$(data_html).hasClass('product-hide')){
                                blocks_parent.append(data_html);
                                section_products_count ++;
                            }
                        }).then(function () {
                            if (section_products_count > 0) {
                                $('.section-recently-viewed').removeClass('hide hidden');
                                theme.carousels.init();
                            }
                        });
                    }
                }
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function() {
    theme.productVariants.init();
    theme.recentlyViewed.init();
});

/*document.addEventListener('DOMContentLoaded', function (){
    let YotpoSubscription = {
        find_block: true,
        init: () => {
            let custom_yotpo_subs_block = document.querySelector('.yotpo-widget-subscriptions-add-to-cart');
            if(custom_yotpo_subs_block && YotpoSubscription.find_block){
                YotpoSubscription.find_block = false;
                setTimeout(function (){
                    YotpoSubscription.actionsBlock(custom_yotpo_subs_block);
                }, 400)
            }
        },
        actionsBlock: (block) => {
            let addition_subs_info = block.querySelector('.yotpo-subscription-benefits-wrapper');
            block.querySelectorAll('input').forEach(function (input, ind){
                input.addEventListener('change', (el)=>{
                   if(el.target.getAttribute('data-selling-plan-name').indexOf('Every') > -1){
                       addition_subs_info.classList.add('active');
                   }else {
                       addition_subs_info.classList.remove('active');
                   }
                });
            })
        }
    }

    let count_at = 25;
    setInterval(()=>{
        if(count_at > 0){
            count_at --;
            YotpoSubscription.init();
        }
    }, 500)

});*/
/*======= Swell-rewards.js =======*/
(function() {
    var timeout = 0;
    if (!window.jQuery) {
        timeout = 1000;
    }

    setTimeout(function() {
        jQuery(document).ready(function($) {
            SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
            SwellConfig.LocalStorage.initializeLocalStorage();

//         $(document).on("swell:cart:updated", function()
//                        {
//           debugger;
//           var cart = $.ajax({
//             type: 'GET',
//             url: '/cart.js',
//             dataType: 'json',
//             success: function(){
//               if(cart.responseJSON.item_count>0){
//                 var isPricedItem = 0;
//                 cart.responseJSON.items.forEach(function(item)
//                                                 {
//                   if(item.final_price > 0)
//                   {
//                     if(item.properties["_swell_discount_type"] === undefined)
//                     {
//                       isPricedItem = 1;
//                       return false;
//                     }
//                   }
//                 });
//                 debugger;
//                 if(isPricedItem == 0)
//                 {
//                   window.location.href = "/cart/clear";
//                 }
//               }
//             }
//           });
//         });

            $('.swell-tier-list').slick({
                dots: false,
                infinite: false,
                speed: 300,
                slidesToScroll:1,
                slidesToShow: 3,
                prevArrow: false,
                nextArrow: false,
                adaptiveHeight:true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight:true,
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots:true,
                        }
                    }
                ]
            });


            $(document).on("swell:setup", function() {
                Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
                SwellConfig.Tier.initializeDummyTier();
                SwellConfig.Referral.initializeReferral(".swell-referral");
                SwellConfig.Customer.initializeHistory(".swell-history-link");

                redemptions = spapi.activeRedemptionOptions;
                redemptions.forEach(function(redemption) {
                    if(redemption.discount_type == "product") {
                        variant_id = redemption.applies_to_id;
                        image = redemption.background_image_url;
                        name = redemption.name;
                        cost = redemption.cost_text;
                        redemption_id = redemption.id;
                        icon= redemption.icon;

                        if(icon.indexOf('regular') >= 0) {
                            $(".product-redemption-options").append('<div class="redeem-for-products-content"> <div class="products-holder"><img class="redeem-for-products-content-image" src=" ' + image +' "> <div class="redeem-for-products-header"> ' + name + ' </div> <div class="swell-details"> ' + cost + ' </div> <ul class="swell-link-list"> <li class="swell-link"> <a href="javascript:void(0);" class="btn sign-up-btn swell-buy-product-btn redeem-btn" data-redemption-option-id="' + redemption_id +'" data-variant-id="' + variant_id +'">Redeem Now </a> </li> </ul><div class="swell-products-hover"><ul class="swell-link-list"> <li class="swell-link"> <a href="/account/register" class="sign-up-btn">sign Up </a> </li> <li class="swell-link"> <a href="/account/login" class="sign-in-btn">sign in </a> </li> </ul></div> </div> </div>');
                        } else if(icon.indexOf('vip') >= 0){
                            $(".exclusive-redemption-options").append('<div class="redeem-for-products-content"> <div class="products-holder"> <img class="redeem-for-products-content-image" src=" ' + image +' "> <div class="redeem-for-products-header"> ' + name + ' </div> <div class="swell-details"> ' + cost + ' </div> <ul class="swell-link-list"> <li class="swell-link"> <a href="javascript:void(0);" class="btn sign-up-btn redeem-btn" data-redemption-option-id="' + redemption_id +'" data-variant-id="' + variant_id +'">Redeem Now </a> </li> </ul><div class="swell-products-hover"><ul class="swell-link-list"> <li class="swell-link"> <a href="/account/register" class="sign-up-btn">sign Up </a> </li> <li class="swell-link"> <a href="/account/login" class="sign-in-btn">sign in </a> </li> </ul></div> </div> </div>');
                            if(spapi.authenticated && spapi.customer.vip_tier != undefined) {
                                $(".exclusive-redemption-options .redeem-btn").addClass('swell-buy-product-btn');
                            } else {
                                $(".exclusive-redemption-options .redeem-btn").addClass('disabled');
                            }
                        }
                    }
                });

                $(".swell-campaign-list .swell-campaign-content[data-campaign-id='536929']").parent().hide();
                $(".swell-campaign-list .swell-campaign-content[data-campaign-id='536930']").parent().hide();
                $(".swell-campaign-list .swell-campaign-content[data-campaign-id='628147'] .swell-campaign-icon .swell-campaign-icon-content").children().addClass("swell-custom_campaign_icon");

                window.onBeforeProductRedemption = function(opts, redemptionOption, pointBalance, cb){
                    if (Swell.Cart.items.length == 0) {
                        content = "Your cart cannot be empty in order to redeem awards"
                        spapi.$.confirm({
                            title: "Oops!",
                            content: content,
                            type: "red",
                            typeAnimated: true,
                            useBootstrap: false,
                            boxWidth: "400px",
                            buttons: {
                                ok: {
                                    text: "Ok",
                                    action: function () {
                                    }
                                }
                            }
                        });
                    } else {
                        cb();
                    }
                };


                swellAPI.refreshEmbeds();

                $("body").on("click", ".refer-friend-btn", function() {
                    $('.swell-link').removeClass('active');
                    $(".referral-content-section").hide();
                    $(".swell-referral-holder").show();
                    $('.swell-referral-holder .refer-friend-btn').parent().addClass('active');
                });

                $("body").on("click", ".referrals-btn", function() {
                    $('.swell-link').removeClass('active');
                    $(".referral-content-section").show();
                    $(".swell-referral-holder").hide();
                    $('.referral-content-section .referrals-btn').parent().addClass('active');
                });

                $('.redeem-for-products-content-holder').slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToScroll: 1,
                    slidesToShow: 4,
                    /*nextArrow: '<div class="icon-holder right-arrow"><i class="swell-icon-right slick-arrows"></i></div>',
                    prevArrow: '<div class="icon-holder left-arrow"><i class="swell-icon-left slick-arrows"></i></div>',
                    */
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                /*centerMode: true,
                                centerPadding: '28.5vw',*/
                                arrows: false,
                                dots: true
                            }
                        }
                    ]
                });

                $(".swell-referral-loader").hide();

                $( 'body' ).on('click',".winky-lux-post-checkout .checkout-heading .swell-referral-back-link", function() {
                    $(".winky-lux-post-checkout").hide();
                });

                setupReferrals();

                $( document ).on('click',"#swell-referral-register-submit", function() {
                    /* Submit your email*/
                    setTimeout(function(){
                        if(spapi.customer.referral_receipts) {
                            setupReferrals();
                            if(spapi.customer.email) {
                                $(".swell-referral-content-main").addClass("refer-step");
                            }
                        } else {
                            setTimeout(function(){
                                setupReferrals();
                                if(spapi.customer.email) {
                                    $(".swell-referral-content-main").addClass("refer-step");
                                }
                            },1000)
                        }
                    },1000)
                });

                $(document).on("swell:referral:success", function() {
                    swellAPI.refreshCustomerDetails(function(){
                        var customerDetails = swellAPI.getCustomerDetails();
                        referrals = customerDetails.referrals;

                        $(".redeem-holder").show();

                        $(".swell-referral-table tbody").html("");

                        referrals.forEach(function(referral) {
                            status = null;

                            if(referral.completedAt){
                                status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
                            } else {
                                status = "Invited";
                            }

                            $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
                        });
                    });
                });

                $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
                    if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
                        $(".refer-customer-error").remove();
                        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
                        $("#swell-referral-refer-emails").addClass("error-border");
                    }

                    if(textStatus && textStatus === "Please enter a valid email address"){
                        $(".refer-customer-error").remove();
                        $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses seperated with commas</p>');
                        $("#swell-referral-refer-emails").addClass("error-border");
                    }
                });

                SwellConfig.Tier.initializeTiers(".swell-tier-table");
            });
        });
    }, 1000);
}).call(this);

function setupReferrals (){
    if(spapi.authenticated || spapi.customer.email) {
        if(spapi.customer.referral_receipts.length > 0) {
            $(".redeem-holder").show();
            $('.link-list-for-member').removeClass('hidden');

            referrals = spapi.customer.referral_receipts;

            referrals.forEach(function(referral) {
                status = null;

                if(referral.completed_at){
                    status = "Purchased(" + spapi.activeReferralCampaign.reward_text + " earned)";
                } else {
                    status = "PENDING";
                }

                $(".swell-referral-table tbody").append('<tr> <td>' +  referral.email + '</td><td>' + status +'</td></tr>');
            });
        }
    }
}

// campaigns
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Campaign = {
        opts: {
            templates: {
                campaign: "<li class='swell-campaign'> <div class='swell-campaign-content' data-display-mode='modal' data-campaign-id='<%= campaign.id %>'> <div class='swell-campaign-icon'> <span class='swell-campaign-icon-content'> <i class='<%= campaign.icon %>'> </i> </span> </div> <div class='swell-campaign-header'> <span class='swell-header-details'><%= campaign.reward_text %></span> </div> <div class='swell-campaign-type'> <span class='swell-details'><%= campaign.title %></span></div><div class='swell-campaign-hover'>" +
                    "<ul class='swell-link-list'> " +
                    "<li class='swell-link'> " +
                    "<a href='/account/register' class='btn sign-up-btn'>JOIN NOW</a> </li> " +
                    "<li class='swell-link'>Already a member? <a href='/account/login' class='sign-in-btn'>Log In </a> </li> </ul></div> </div> </li>",
            }
        }
    };
}).call(this);

// history popup
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Customer = {
        initializeHistory: function(containerSelector) {
            return $(containerSelector).click(function() {
                return swellAPI.showPopupByType("HistoryPopup");
            });
        }
    };
}).call(this);

// links
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Link = {
        initializeLinks: function(containerSelector) {
            return $(document).on("click", containerSelector, function(e) {
                var href;
                e.preventDefault();
                href = $(this).attr("href");
                localStorage.setItem("swell-location", "/pages/rewards");
                return window.location = href;
            });
        }
    };
}).call(this);

// local storage
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.LocalStorage = {
        initializeLocalStorage: function() {
            var location;
            location = localStorage.getItem("swell-location");
            if (location && window.location.pathname === '/account') {
                localStorage.removeItem("swell-location");
                return window.location = location;
            }
        }
    };
}).call(this);

// referral
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Referral = {
        opts: {
            localization: {
                referralSidebarDetailsAction: "Refer a Friend",
                referralSidebarDetailsReward: "<%= referralCampaign.reward_text %>",

                referralRegisterHeading: " Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
                referralRegisterFormDetails: "Submit your email to get started.",
                referralRegisterFormEmail: "Your Email Address",
                referralRegisterFormSubmit: "Next",
                referralRegisterDetails: "<%= referralCampaign.details %>",

                referralReferHeading: "Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %>",
                referralReferFormEmails: "Your friends' emails (separated by commas)",
                referralReferFormSubmit: "Next",
                referralReferFormDetails: "Now, enter your friends' emails below.",
                referralReferFormEmailsDetails: "",
                referralReferDetails: "<%= referralCampaign.details %>",

                referralReferMediaDetails: "Or share your referral link:",

                referralShareFacebook: "Facebook",
                referralShareTwitter: "Tweet",
                referralShareCopy: "Copy Link",
                referralShareMessenger: "Message",
                referralShareSMS: "SMS",

                referralFacebookIcon: "swell-icon-facebook-share-mob",
                referralTwitterIcon: "swell-icon-tweet-mob",
                referralLinkIcon: "swell-icon-copy-link-mob",
                referralMessengerIcon: "swell-icon-fb-message-mob",
                referralSMSIcon: "swell-icon-sms-mob",

                referralThanksHeading: "Thanks for <br>spreading the love.",

                referralThanksSubHeading: "Nudge your friends to check their emails.",

                referralThanksDetails: "To redeem points earned from referrals, simply apply your points at checkout for a discount.",

                referralThanksButton: "TELL MORE FRIENDS",

                referralCopyHeading: "",
                referralCopyButton: "Copy Link",
                referralCopyDetails: "Copy and share link with your friends"
            },
            templates: {
                referralRegister: '<div class="swell-referral-register"> ' +
                    '<h1 class="swell-referral-heading align-left"><span class="refer-heading">Refer a Friend</span><%= localization.referralRegisterHeading %></h1> ' +
                    '<p class="swell-referral-details"><!--<%= localization.referralRegisterDetails %>-->Hook your friends up with $15 off their first order of $30+, and get $15 in Winky Rewards points for each successful referral.</p> ' +
                    '<div class="swell-referral-form-wrapper"> ' +
                    '<form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> ' +
                        '<div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><!--<%= localization.referralRegisterFormDetails %>-->Let’s start with your email.</p> </div> ' +
                        '<div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> ' +
                            '<li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>">' +
                                '<p class="info-privacy-policy">By submitting your email you agree to our <a href="/pages/terms-of-service">Terms and Conditions</a> and <a href="/pages/privacy-policy">Privacy Policy</a>.</p>' +
                                '<input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> ' +
                    '</form> </div> </div>',
                referralRefer: '<div class="swell-referral-refer"> <ul class="swell-link-list link-list-for-member hidden"> ' +
                    '<li class="swell-link active"> <a href="javascript:void(0)" class="sign-up-btn refer-friend-btn">Refer a friend </a> </li> ' +
                    '<li class="swell-link"> <a href="javascript:void(0)" class="sign-in-btn referrals-btn">Your referrals </a> </li> </ul> ' +
                    '<h2 class="swell-referral-heading"><span class="refer-heading">Refer a Friend</span><%= localization.referralReferHeading %></h2> ' +
                    '<p class="swell-referral-details"><!--<%= localization.referralReferDetails %>-->Hook your friends up with $15 off their first order of $30+, and get $15 in Winky Rewards points for each successful referral.</p> ' +
                    '<div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> ' +
                    '<div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> ' +
                    '<ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span><p class="info-privacy-policy">By submitting your email you agree to our <a href="/pages/terms-of-service">Terms and Conditions</a> and <a href="/pages/privacy-policy">Privacy Policy</a>.</p>' +
                    '<input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> </form> </div> ' +
                    '<div class="swell-referral-media-wrapper"><p><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list">' +
                    '<li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> ' +
                    '<li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareTwitter %> </div> </li> ' +
                    '<li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> ' +
                    '<li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralMessengerIcon %>" aria-hidden="true"> <span class="path1"></span> <span class="path2"></span> </i> &nbsp; <span><%= localization.referralShareMessenger %> </span> </div> ' +
                    '</li><!-- <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralSMSIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareSMS%> </div> </li> --></ul> </div> </div>'
            }
        },
        initializeReferral: function(containerSelector) {
            var email = $(containerSelector).data("customer-email");
            if (email) {
                spapi.storage.setItem("referrer_email", email);
                spapi.customer.email = email;
            }
            Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
        }
    };
}).call(this);

// tiers
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Tier = {
        getCustomerTierId: function() {
            var customer_tier, intro_tier, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier) {
                return customer_tier.id;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].id;
                } else {
                    return null;
                }
            }
        },
        getCustomerTierRank: function() {
            var customer_tier, intro_tier, rank, tiers;
            customer_tier = spapi.customer.vip_tier;
            tiers = spapi.activeVipTiers;
            if (customer_tier && customer_tier.id) {
                rank = $.grep(tiers, function(e) {
                    return e.id === customer_tier.id;
                })[0].rank;
                return rank;
            } else {
                intro_tier = $.grep(tiers, function(e) {
                    return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
                });
                if (intro_tier.length > 0) {
                    return intro_tier[0].rank;
                } else {
                    return null;
                }
            }
        },
        getTierByRank: function(rank) {
            var tiers;
            tiers = spapi.activeVipTiers;
            return $.grep(tiers, function(e) {
                return e.rank === rank;
            })[0];
        },
        setupCustomerTierStatus: function() {
            customer_tier_id = SwellConfig.Tier.getCustomerTierId();
            customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
            next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);

            $(".tier-list-item[data-tier-id='"+ customer_tier_id +"'] .current-tier").html("CURRENT STATUS");

            if(next_tier) {
                if(spapi.customer.vip_tier_stats) {
                    tier_difference = (next_tier.amount_spent_cents - spapi.customer.vip_tier_stats.amount_spent_cents)/100;
                } else {
                    tier_difference = (next_tier.amount_spent_cents - 0)/100;
                }
            }

           /* if(next_tier) {
                $(".tier-list-item[data-tier-id='"+ next_tier.id +"'] .current-tier").html("SPEND $" + tier_difference + " more ..");
            }*/
        },
        initializeDummyTier: function() {
            var k, len, tier, tiers;
            tiers = spapi.activeVipTiers;
            for (k = 0, len = tiers.length; k < len; k++) {
                tier = tiers[k];
                tier.rank += 1;
            }
            return tiers.unshift({
                id: -1,
                rank: 0,
                name: "(Re)sister",
                points: "$0&ndash;$199",
                one_point_multiplier: "<i class=\"fa fa-check\" aria-hidden=\"true\"></i>",
                birthday_points: "<i class=\"fa fa-check\" aria-hidden=\"true\"></i>",
                exclusive_products: "",
                free_product: "",
                two_point_multiplier: "",
                swellrequiredAmountSpent: "$0",
                swellrequiredAmountSpentCents: 0,
                swellrequiredPointsEarned: 0,
                swellrequiredPurchasesMade: 0,
                swellrequiredReferralsCompleted: 0
            });
        },
        initializeTiers: function(containerSelector) {
            if (spapi.authenticated) {
                SwellConfig.Tier.setupCustomerTierStatus();
            }
        }
    };
}).call(this);
/*======= End swell-rewards.js =======*/

(function() {
    $('.js__add-to-cart').click(function (e){
        e.preventDefault();
        theme.productVariants.pairsAdd($(this));
    });

    $('.cc-accordion-item__content').each(function() {
        $(this).find('.cc-filter-group').each(function() {
            if ($(this).find('label').length === 0) {
                $(this).prev('.filter-group-title').hide();
                $(this).remove();
            }
        });
    });

    $('.color-swatch--more').click(function (){
        if($(this).hasClass('open-swatches')){
            $(this).removeClass('open-swatches');
            if($(this).hasClass('drawer-swatch')){
              //  $(this).parent().find('.color-swatch.hide-on-drawer').addClass('hide');
            }else if(window.innerWidth > 1279){
                $(this).parent().find('.color-swatch.hide-on-desktop').addClass('hide');
            }else{
                $(this).parent().find('.color-swatch.hide-on-small-screens').addClass('hide');
            }
        }else if($(this).hasClass('drawer-swatch')){
           // $(this).addClass('open-swatches').parent().find('.color-swatch.hide-on-drawer.hide').removeClass('hide');
        }else{
            $(this).addClass('open-swatches');
            if(window.innerWidth > 1279){
                $(this).parent().find('.color-swatch.hide-on-desktop').removeClass('hide');
            }else{
                $(this).parent().find('.color-swatch.hide-on-small-screens').removeClass('hide');
            }
        }
    });

    if($('.component--bundle').length > 0){
        theme.bundle.completeProductBundle();
        if($('.component--bundle__variants-button').length > 0){
            theme.bundle.openProductBundle();
        }
    }

    $(document).on('click', (function(e) {
        var $modalContent = $('.cc-product-filter');
        if ($modalContent.is(':visible') && !$(e.target).closest('.cc-product-filter').length) {
            if($('body').hasClass('show-filters-page')){
                $('section.collection-page').toggleClass('cc-filters-mob-open');
                $('form.cc-product-filter').removeClass('open-drawer');
                $('body').removeClass('show-filters-page');
            }
        }

    }).bind(this));

}).call(this);







